<template>
  <div class="receipt page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Receipts')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_receipt'" @click="showModal">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{$t('New Receipt')}}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <ReceiptTable/>
    </div>
  </div>
</template>

<script>
  import ReceiptTable from "./ReceiptTable";
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../core/components/page-header/PageHeader";

  const {mapActions} = createNamespacedHelpers('receipts');
  export default {
    name: "Receipt",
    components: {PageHeader, AddNewButton, ReceiptTable},
    methods: {
      ...mapActions(['showModal', 'updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({source: 'receipt'});
    }
  }
</script>

<style lang="scss" scoped>
</style>

